<template>
     <section class="section-80 section-lg-60">
        <div class="container">
          <div class="nav-custom row d-flex flex-row justify-center align-center mb-5">
            <div class="col-md-2 col-4 text-center px-0" style="border:1px solid #d7d7d7;"><a style="padding:8px 15px;" href="/login">Login</a></div>
            <div class="col-md-2 col-4 text-center px-0" style="border:1px solid #d7d7d7;"><a class="active" style="padding:8px 15px;" href="/register">Register</a></div>
          </div>
          <div class="row row-offset-2 justify-content-sm-center">
            <div class="col-md-8 col-lg-6 col-xl-4">
              <!-- RD Mailform-->
              <v-form v-model="valid" @submit.prevent="submitForm()" class="rd-mailform rd-form text-left" data-form-output="form-output-global" data-form-type="contact">
                <div class="form-wrap">
                  <label class="form-label-outside" for="login">First Name</label>
                  <v-text-field v-model="personal.firstName" class="form-input form-input-gray" id="login" type="text" name="login" data-constraints="@Required"></v-text-field>
                </div>
                <div class="form-wrap">
                  <label class="form-label-outside" for="login">Middle Name</label>
                  <v-text-field v-model="personal.middleName" class="form-input form-input-gray" id="login" type="text" name="login" data-constraints="@Required"></v-text-field>
                </div>
                <div class="form-wrap">
                  <label class="form-label-outside" for="login">Last Name</label>
                  <v-text-field v-model="personal.lastName" class="form-input form-input-gray" id="login" type="text" name="login" data-constraints="@Required"></v-text-field>
                </div>
                <div class="form-wrap">
                  <label class="form-label-outside" for="login">Phone Number</label>
                  <v-text-field v-model="personal.phoneNumber" class="form-input form-input-gray" id="phone" type="text" name="phone" data-constraints="@Required"></v-text-field>
                </div>
                <div class="form-wrap">
                  <label class="form-label-outside" for="email">E-mail</label>
                  <v-text-field v-model="personal.email" class="form-input form-input-gray" id="email" type="text" name="email" data-constraints="@Required @Email"></v-text-field>
                </div>
                <div class="form-wrap">
                  <label class="form-label-outside" for="password">Password</label>
                  <v-text-field v-model="personal.password" class="form-input form-input-gray" id="password" type="password" name="password" data-constraints="@Required"></v-text-field>
                </div>
                <div class="form-wrap">
                  <label class="form-label-outside" for="password2">Confirm Password</label>
                  <v-text-field v-model="personal.rePassword" class="form-input form-input-gray" id="password2" type="password" name="password2" data-constraints="@Required"></v-text-field>
                </div>
                <button class="button button-primary button-block button-sm" type="submit">registration</button>
              </v-form>
            </div>
          </div>
        </div>
      </section>
</template>

<script>
import axios from 'axios';
import { getConfigDataFromLocalStorage } from '@/localStorageData/localStorageUtil.js';
export default {
    data(){
        return{
        personal: {
            firstName: "",
            middleName:"",
            lastName:"",
            email: "",
            password: "",
            rePassword: "",
            phoneNumber:""
        },
        data1: {
            "request_type": "user_register",
            "user_name": "",
            "email": "",
            "password": "",
            "portal_id": "",
            "portal_group_id": "",
            "user_id": "",
        },


        firstName: [
            v => !!v || 'Please enter your First Name',
            v => (v.length >= 3) || 'Name must be greater than 3 ',
        ],
        middleName: [
            v => !!v || 'Please enter your Middle Name',
            v => (v.length >= 3) || 'Name must be greater than 3 ',
        ],
        lastName: [
            v => !!v || 'Please enter your Last Name',
        ],

        eMail: [
            v => !!v || 'E-mail is required',
            v => /.+@.+/.test(v) || 'E-mail must be valid',
        ],
        phone_no:[
            v => /^[0-9]*$/.test(v) || 'Only numbers are allowed',
        ],

        passWord: [
            v => !!v || 'Please enter your Password',
        ],
        repassWord: [
            v => !!v || 'Please enter your Re-password',
            v => v === this.personal.password || 'Passwords do not match'
        ],

        registerReq: {
            "request_type": "user_register",
            "first_name": "",
            "middle_name":"",
            "last_name":"",
            "email": "",
            "password": "",
            "portal_id": "",
            "portal_group_id": "",
            "user_id": "",
            "token": "Tc7RQaX79Hrx5CFK",
            "portal_domain": "",
        },
        portal_group_id:"",
        portal_id:"",
        registerUrl: "",
        portal_domain:"",
        }
    },
    methods:{
        closeDialog(){
            setInterval(() => {
                location.reload();
            }, 200);
        },
        submitForm() {

        console.log(this.valid, 'oooooooooo')
        if (this.valid) {

            this.loadRegister = true
            this.btnDisabled = true

            // this.generateBookingRefId()

            console.log(this.personal, 'eeeee......')


            this.registerReq.first_name = this.personal.firstName
            this.registerReq.middle_name = this.personal.middleName
            this.registerReq.last_name = this.personal.lastName
            this.registerReq.email = this.personal.email
            this.registerReq.password = this.personal.password
            this.registerReq.user_id = this.personal.email
            this.registerReq.portal_id = this.portal_id
            this.registerReq.portal_group_id = this.portal_group_id
            this.registerReq.portal_domain = this.portal_domain

            console.log(this.registerReq, 'ffff.....')

            axios.post(this.registerUrl, this.registerReq, {
            headers: {
                'Content-Type': 'application/json'
            }
            })
            .then(response => {

                if (response.data) {
                this.regForm = false
                this.regMsg = true
                console.log('Response:', response.data);
                console.log('Response-Msg:', response.data.register.message);
                this.registerMsg = response.data.register.message

                // this.registerbox = false
                }
            })


            .catch(error => {
                this.regErr = true;
                console.log(error.response.data.message, 'wejjfuoajk')
                // alert(`${error.response.data.message}`)
                this.errorMsg = error.response.data.message
                this.loadRegister = false
                this.btnDisabled = false
            });
        }
        },
        getConfig() {
      this.dataloader = false
      // let portalLocal = localStorage.getItem("portalData")
      // let getConfigData1 = JSON.parse(portalLocal)
      const getConfigData1 = getConfigDataFromLocalStorage();
      if (getConfigData1) {
        this.registerUrl = getConfigData1.payload.portal_configuration.API_endpoints.b2cregister
        console.log(this.registerUrl, 'head...reg..1..')
        this.portal_id = getConfigData1.payload.portal_configuration.portal_id;
        this.portal_group_id = getConfigData1.payload.portal_configuration.portal_group_id;
        this.portal_domain = getConfigData1.payload.portal_configuration.portal_url.replace("https://","");
      }
    },
    },
    created(){
        this.getConfig();
    }
}
</script>

<style scoped>
ul{
    padding-left:0px;
}
button{
    color:white;
}
.nav-custom{
    border:none;
}
.col-2{
    width:12%;
}
:deep(.v-input__details){
    display:none;
}
:deep(.v-field--variant-filled .v-field__outline::before){
    border-style:none;
}
:deep(.v-field--variant-filled .v-field__outline::after){
    border-style:none;
}
:deep(.v-field__input){
    background-color:white;
}
:deep(.v-input){
    padding:0px;
}
</style>